<template lang="pug">
div
  template(v-if="!readonly")
    v-autocomplete.text-sm.round-xl.mt-6.autocmplt(ref="autocmplt" v-model="segment" :items="segmentList" item-text="title" return-object :search-input.sync="searchSegments" placeholder="Search and select here" :loading="isSearching" outlined dense clearable height="48" hide-details="auto" hide-no-data attach append-icon="" @change="addToList(segment)" @focus="fetchSegments()" @blur="clearAutocomplete")
      template(#prepend-inner)
        v-icon.mt-1(size="22") $yzi-search-sm
      template(#item="{ index, item }")
        div.py-3.px-2
          .text-sm.font-normal {{ item.title }}
          .d-flex
            .d-flex.align-center.mr-4
              v-icon.mr-1(size="14" color="neutral500") $yzi-users-02
              .text-xs.font-normal.neutral500--text Customers: {{ item.total_customers }}
            .d-flex.align-center.mr-4
              template(v-if="item.dynamic")
                v-avatar.mr-2(size="8" color="blue500")
                .text-xs.font-normal.neutral500--text Dynamic segment
              template(v-else)
                v-avatar.mr-2(size="8" color="success500")
                .text-xs.font-normal.neutral500--text Fixed segment
              
          .text-xxs.font-normal.italic.danger500--text(v-if="item.hasError") {{ item.errorMessage }}

  v-card.mt-5(outlined)
    v-row.pa-4(v-if="segments.length && !readonly" align="center")
      v-col
        div.text-sm.font-medium.neutral700--text Selected:
      v-col
        div.d-flex.align-center
          v-spacer
          v-btn(@click="clickSearch" icon color="neutral500")
            v-icon(size="20") $yzi-search-sm
          v-text-field(v-if="showSearchField" v-model="searchText" @input="queryChanged" solo dense flat :placeholder="$t('type_to_search')" hide-details clearable autofocus)
          v-menu(offset-y left attach rounded="lg" min-width="100")
            template(#activator="{ on }")
              v-btn.mx-3(icon small v-on="on")
                v-icon $yzi-filter-line
            v-list.py-0
              v-list-item(@click="sortAsc")
                v-list-item-title.text-sm.basic800--text A-Z
              v-divider
              v-list-item(@click="sortDesc")
                v-list-item-title.text-sm.basic800--text Z-A
          y-button(label="Clear all" size="sm" underline button-class="px-0" @click="resetSearch")
      
    v-data-table(:headers="headers" :items="searchText ? filterSegments : segments" item-key="id" :items-per-page="pageSize" hide-default-header hide-default-footer disable-sort :loading="isSelecting" :header-props="{ sortIcon: '$yzi-triangle' }")
      template(#no-data)
        div.empty-box.mt-6.pa-8(align="center")
          v-avatar(color="neutral300" size="60")
            v-icon(color="neutral500" size="30") $yzi-users-03
          div.text-center.text-md.font-semibold.neutral700--text.mt-6 No segment selected
          div.text-center.text-sm.font-normal.neutral500--text.mt-1 Selected segment will be displayed here
      //- title
      template(v-slot:item.title="{ item }")
        div.py-2
          .text-sm.font-medium.neutral700--text {{ item.title }}
          .d-flex.mt-1
            .d-flex.align-center.mr-4
              v-icon.mr-1(size="14" color="neutral500") $yzi-users-02
              .text-xs.font-normal.neutral500--text Customers: {{ item.total_customers }}
            .d-flex.align-center.mr-4
              template(v-if="item.dynamic")
                v-avatar.mr-2(size="8" color="blue500")
                .text-xs.font-normal.neutral500--text Dynamic segment
              template(v-else)
                v-avatar.mr-2(size="8" color="success500")
                .text-xs.font-normal.neutral500--text Fixed segment
      //- check
      template(v-slot:item.check="{ item }")
        div.py-2
          yc-checkbox(v-model="item.include_later_members")
            template(v-slot:label)
              div.text-xs.neutral700--text.ml-3 Include upcoming newly added customers
      //- action
      template(v-slot:item.action="{ item }")
        div.d-flex.justify-end
          v-btn(icon small @click="deleteSegment(item)")
            v-icon $yzi-trash-03

    div.py-2
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    value: {
      required: true,
      type: Array,
      default: (() => [])
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isSelecting: false,
      isSearching: false,
      showSearchField: false,
      searchText: null,
      searchSegments: null,
      segment: null,
      pageSize: -1,
      segmentList: [],
      filterSegments: [],
    }
  },
  computed: { 
    ...mapGetters({ company: 'getCompany' }),
    headers () {
      let headers = [
        { text: 'Title', value: 'title' },
        { text: 'Check', value: 'check', },
        { text: '', value: 'action', },
      ]
      if (this.readonly) {
        headers.pop()
        headers.pop()
      }
      return headers
    },
    segments: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
  },
  watch: {
    searchSegments (val) {
      if (val) {
        this.fetchSegments(val)
      }
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchSegments (search) {
      this.isSearching = true
      let params = {
        ordering: '-id',
        exclude: 'customer',
        enabled: true,
        page_size: -1
      }
      if (search) {
        params.search = search
      }
      this.$axios.get(`/connect/${this.company.slug}/groups`, { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.segmentList = resp.data.results.map(m => { return { ...m, include_later_members: false } } )
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isSearching = false
        })
    },
    addToList (segment) {
      this.resetSearch()
      if (segment) {
        if (this.segments.find(f => f.id === segment.id)) {
          return
        }
        this.segments.push(segment)
        this.$refs.autocmplt.blur()
      }
    },
    deleteSegment (segment) {
      this.resetSearch()
      this.segments = this.segments.filter(f => f.id !== segment.id)
    },
    clearAutocomplete () {
      this.segment = null
      this.searchSegments = null
      setTimeout(() => {
        this.segmentList = []
      }, 300)
    },
    queryChanged () {
      if (this.searchText) {
        this.filterSegments = this.segments.filter(f => f.title.toLowerCase().includes(this.searchText.toLowerCase()))
      }
    },
    clickSearch () {
      this.searchText = null
      this.filterSegments = []
      this.showSearchField = !this.showSearchField
    },
    sortAsc () {
      this.segments = this.segments.sort((a, b) => a.title.localeCompare(b.title))
    },
    sortDesc () {
      this.segments = this.segments.sort((a, b) => b.title.localeCompare(a.title))
    },
    resetSearch () {
      this.searchText = null
      this.filterSegments = []
      this.showSearchField = false
    }
  }
}
</script>

<style scoped>
.column-width {
  width: 200px;
}
::v-deep .v-data-table__wrapper table tbody tr:hover{
  cursor: pointer;
  background: var(--v-neutral200) !important; 
}
</style>